import React from "react";

import { Row, Col } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';
import Carousel from 'react-bootstrap/Carousel'

// CSS Files
import "../../Fonts/Fonts.css";
import "../../Statics/Common/FontStyle.css";

// JS Files
import SlideShow from './SlideShow.js';

const Slider = props => {
     return props.size === "laptopdesktop" ? (
          <div>
               <SlideShow
                    autoPlay={true}
                    activeSlideDuration={5000}
                    interactionMode="swipe"
                    alignCaption="center"
                    alignIndicators="center"
                    indicatorsColor="#fff"
                    useRightLeftTriangles={true}
                    rightTriangleColor="#fff"
                    leftTriangleColor="#f3f3f3"
                    rightIcon={
                         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                              <path d="M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z" />
                         </svg>
                    }
                    leftIcon={
                         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                              <path d="M231.293 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L70.393 256 251.092 74.87c4.686-4.686 4.686-12.284 0-16.971L231.293 38.1c-4.686-4.686-12.284-4.686-16.971 0L4.908 247.515c-4.686 4.686-4.686 12.284 0 16.971L214.322 473.9c4.687 4.686 12.285 4.686 16.971-.001z" />
                         </svg>
                    }
               >
                    <div>
                         <img

                              src={require("../../Imgs/HomePage/Slider1.jpg")}
                              alt="First slide"
                         />
                    </div>
                    <div>
                         <img

                              src={require("../../Imgs/HomePage/Slider2.jpg")}
                              alt="First slide"
                         />
                    </div>
                    <div>
                         <img

                              src={require("../../Imgs/HomePage/Slider3.jpg")}
                              alt="First slide"
                         />
                    </div>
               </SlideShow>
          </div>
     ) : props.size === "tablet" ? (
          <div>
               <SlideShow
                    autoPlay={true}
                    activeSlideDuration={5000}
                    interactionMode="swipe"
                    alignCaption="center"
                    alignIndicators="center"
                    indicatorsColor="#fff"
                    useRightLeftTriangles={true}
                    rightTriangleColor="#fff"
                    leftTriangleColor="#f3f3f3"
                    rightIcon={
                         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                              <path d="M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z" />
                         </svg>
                    }
                    leftIcon={
                         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                              <path d="M231.293 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L70.393 256 251.092 74.87c4.686-4.686 4.686-12.284 0-16.971L231.293 38.1c-4.686-4.686-12.284-4.686-16.971 0L4.908 247.515c-4.686 4.686-4.686 12.284 0 16.971L214.322 473.9c4.687 4.686 12.285 4.686 16.971-.001z" />
                         </svg>
                    }
               >
                    <div>
                         <img

                                   src={require("../../Imgs/HomePage/Slider1.jpg")}
                              alt="First slide"
                         />
                    </div>
                    <div>
                         <img

                                   src={require("../../Imgs/HomePage/Slider2.jpg")}
                              alt="First slide"
                         />
                    </div>
                    <div>
                         <img

                                   src={require("../../Imgs/HomePage/Slider3.jpg")}
                              alt="First slide"
                         />
                    </div>
               </SlideShow>
          </div>
     ) : (
                    <div>
                          <Carousel indicators={false}>
                                 <Carousel.Item>
                                        <img
                                             className="homepageSlider"
                                             src={require("../../Imgs/HomePage/Slider1.jpg")}
                                        />
                                 </Carousel.Item>
                                 <Carousel.Item>
                                   <img
                                        className="homepageSlider"
                                        src={require("../../Imgs/HomePage/Slider2.jpg")}
                                   />
                                 </Carousel.Item>
                                 <Carousel.Item>
                                   <img
                                        className="homepageSlider"
                                        src={require("../../Imgs/HomePage/Slider3.jpg")}
                                   />
                                 </Carousel.Item>
                         </Carousel>
                         
                    </div>
               );
};

export default Slider;
